// extracted by mini-css-extract-plugin
export default {"wrapper":"Editable_wrapper__wyung","wrapper__date":"Editable_wrapper__date__OwK6z"};